import { ICountrysideBuildersCallbackProps } from '@cian/frontend-builders-callback-widget';
import { TDeviceType, useDeviceType } from '@cian/ui-kit';
import { useMemo } from 'react';
import { ECallbackWidgetPlacement } from '../../../types/callbackWidget';

export type TButtonProps = Partial<Record<TDeviceType, ICountrysideBuildersCallbackProps['buttonProps']>>;

export const GALLERY_BUTTON_PROPS: TButtonProps = {
  desktop: { theme: 'fill_white_secondary', size: 'XS' },
  tablet: { theme: 'fill_primary', text: 'Получить консультацию' },
  phone: { theme: 'fill_primary', text: 'Консультация' },
};

export const TOUR_BUTTON_PROPS: TButtonProps = {
  desktop: { fullWidth: true, theme: 'fill_secondary' },
  tablet: { theme: 'fill_primary', text: 'Получить консультацию' },
  phone: { theme: 'fill_primary', text: 'Консультация' },
};

export const AUTHOR_BUTTON_PROPS: TButtonProps = {
  desktop: { size: 'XS', theme: 'fill_secondary' },
  tablet: { theme: 'fill_secondary' },
  phone: { theme: 'fill_secondary' },
};

export const SIDEBAR_BUTTON_PROPS: TButtonProps = {
  desktop: { theme: 'fill_secondary' },
};

export const useCallbackButtonProps = (
  placement: ECallbackWidgetPlacement,
): ICountrysideBuildersCallbackProps['buttonProps'] => {
  const deviceType = useDeviceType();

  return useMemo(() => {
    switch (placement) {
      case ECallbackWidgetPlacement.Sidebar:
        return SIDEBAR_BUTTON_PROPS[deviceType];

      case ECallbackWidgetPlacement.Gallery:
        return GALLERY_BUTTON_PROPS[deviceType];

      case ECallbackWidgetPlacement.Tour:
        return TOUR_BUTTON_PROPS[deviceType];

      case ECallbackWidgetPlacement.Author:
        return AUTHOR_BUTTON_PROPS[deviceType];

      default:
        return;
    }
  }, [deviceType, placement]);
};
